var App = App || {};

App.Speedbump = (function ($) {
    'use strict';

    var exclusions = $("#sbModal").data("exclusions").split(","),
        uriSchemes = ['javascript:', 'mailto:', 'tel:'],
        
        $loginModal = $('#loginModal');

    function init() {
        $('a').on('click.speedbumpcheck', function (e) {
            var $this = $(this),
                url = $this.attr('href');

            if ($this.hasClass("speedbump-continue-button")) {
                // Continue button of the Speedbump modal itself.
                e.preventDefault();

                window.open(url);
                $('#sbModal').modal('hide');
            }
            else if ($this.hasClass('show-login-modal')) {
                e.preventDefault();

                $loginModal.find('.modal-title').html($this.data('loginmodaltitle'));
                $loginModal.find('.modal-body').html($this.data('loginmodalcontent'));

                // Clicking this anchor will also trigger click.speedbumpcheck;
                $loginModal.find('#loginModalSubmit')
                    .attr('href', url)
                    .off('click.loginmodalsubmit')
                    .on('click.loginmodalsubmit', function () {
                        $loginModal.modal('hide');
                    });

                $loginModal.modal('show');
            }
            else if (isSpeedbumpUrl(this.hostname, url)) {

                var hostname = this.hostname,
                    specTrigFound = false,
                    triggers;

                $(".specific-trigger-sb").each(function () { //check each specific trigger speedbump for this url
                    triggers = $(this).data("triggers").split(",");
                    if ($.inArray(hostname, triggers) != -1 && !specTrigFound) {
                        e.preventDefault();
                        $(this).modal('show');
                        $("#btn-" + $(this).attr("id")).attr('href', url);
                        specTrigFound = true;
                    }
                });
                if (!specTrigFound) {
                    showSpeedbump(e, url);
                }
            }
        });
    }

    function showSpeedbump(e, url) {
        e.preventDefault();

        $('#sbModal').modal('show');
        $('#sbModalSubmit').attr('href', url);
    }

    function isSpeedbumpUrl(hostname, url) {
        return hostname !== location.hostname
            && $.inArray(hostname, exclusions) === -1
            && url
            && url.indexOf('#') !== 0
            && !isUriSchema(url);
    }

    function isUriSchema(url) {
        for (var i in uriSchemes) {
            if (url.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Speedbump.init();
});